module.exports = __webpack_public_path__ + "static/thermostat-7e53619c65f7ab45bf1f50846fea9815.jpg";